import { render, staticRenderFns } from "./RadioButtonTapWithIcon.vue?vue&type=template&id=05387e6c&scoped=true&"
import script from "./RadioButtonTapWithIcon.vue?vue&type=script&lang=js&"
export * from "./RadioButtonTapWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./RadioButtonTapWithIcon.vue?vue&type=style&index=0&id=05387e6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05387e6c",
  null
  
)

export default component.exports